export default __webpack_public_path__ + "static/media/googlePlay.42e5e6e9.svg";